import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-a89deca8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "full-name-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_menu, {
    "nudge-width": 300,
    activator: "parent"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "mx-auto",
        width: "220"
      }, {
        title: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.getUserFullName()), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_list, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_group, { value: "$t('i18n.language')" }, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_list_item, _mergeProps(props, {
                    "prepend-icon": "mdi-translate",
                    title: _ctx.$t('i18n.language')
                  }), null, 16, ["title"])
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableLocales, (locale) => {
                    return (_openBlock(), _createBlock(_component_v_list_item, {
                      key: `locale-${locale}`,
                      value: locale,
                      onClick: ($event: any) => (_ctx.selectLanguage(locale))
                    }, {
                      prepend: _withCtx(() => [
                        (_ctx.currentLanguage === locale)
                          ? (_openBlock(), _createBlock(_component_v_icon, {
                              key: 0,
                              icon: "mdi-check"
                            }))
                          : (_openBlock(), _createBlock(_component_v_icon, { key: 1 }))
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, {
                          textContent: _toDisplayString(locale)
                        }, null, 8, ["textContent"])
                      ]),
                      _: 2
                    }, 1032, ["value", "onClick"]))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_list_item, { onClick: _ctx.logoff }, {
                prepend: _withCtx(() => [
                  _createVNode(_component_v_icon, { icon: "mdi-logout" })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('i18n.logoff')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}